import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  OnboardingLivesTab,
  onboardingLivesPathOf,
} from "../OnboardingLivePaths.ts";

type OnboardingLivesListLocationState = { onboardingLivesListUrl?: string };

export function useOpenFromOnboardingLivesList() {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  return useCallback(
    (path: string) => {
      const state: OnboardingLivesListLocationState = {
        onboardingLivesListUrl: `${pathname}${search}`,
      };
      navigate(path, { state });
    },
    [navigate, pathname, search],
  );
}

export function useBackToOnboardingLivesList(fallbackTab: OnboardingLivesTab) {
  const navigate = useNavigate();
  const { state } = useLocation();
  const listUrl = (state as OnboardingLivesListLocationState | null)
    ?.onboardingLivesListUrl;
  return useCallback(
    () => navigate(listUrl ?? onboardingLivesPathOf(fallbackTab)),
    [navigate, listUrl, fallbackTab],
  );
}
